import styled from "styled-components";
import { i18n } from "../../../../../translate/i18n";
import moment from 'moment';

export const handlePropsStage = (stage, showInCalendarAsScheduledInGreen, showInCalendarAsInProgressInGreen) => {
  if(stage === 'overdue' || stage === 'pending' || stage === 'expired') {
    return '#FA7D7D'
  }
  else if(stage === 'scheduled' && !showInCalendarAsScheduledInGreen) {
    return '#457CDA'
  }
  else if(stage === 'progress' && !showInCalendarAsInProgressInGreen) {
    return '#457CDA'
  }
  else {
    return 'green';
  }
}

const handlePropsStatus = (status, props) => {
  switch (status) {
    case i18n.t('maintenancesStatusLabel.title'): // 'Em Progresso'
      if(status === i18n.t('maintenancesStatusLabel.title') && new Date() > moment(new Date(props?.returnFromMaintenanceDate)).endOf('day').toDate()) {
        return '#FA7D7D'
      } else {
        return '#ffd700'
      }
      
    case i18n.t('maintenancesStatusLabel.title5'): // 'Vencida'
      return '#FA7D7D'

    case i18n.t('maintenancesStatusLabel.title4'): // 'Pendente'
      if(new Date() > moment(new Date(props?.sendToMaintenanceDate)).endOf('day').toDate()) {
        return '#FA7D7D'
      } else {
        return '#457CDA'
      }

    case i18n.t('maintenancesStatusLabel.title1'): // 'Cancelada'
      return  'black'
    case i18n.t('maintenancesStatusLabel.title2'): // 'Concluída'
      if(status === i18n.t('maintenancesStatusLabel.title2') && props?.expiration !== null && new Date() > moment(new Date(props?.expiration)).endOf('day').toDate()) {
        return 'red'
      } else {
        return 'green'
      }

    default:
      return 'green';
  }
}

export const Container = styled.div`
  background-color: #fff;
  align-items: center;
  padding: 15px;
  border-left-color: ${props => props.stage ? handlePropsStage(props.stage, props.showInCalendarAsScheduledInGreen, props.showInCalendarAsInProgressInGreen) : handlePropsStatus(props.statusColor, props.props)};
  /* border-left-color: ${props => props.stage === 'overdue' ? '#FA7D7D' : props.stage === 'scheduled' ? '#457CDA' : 'green'}; */
  border-left-width: 5px;
  border-left-style: solid;
  margin-bottom: 20px;
`;
